<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header></Header>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb"><a href="/tw/">首頁</a><span class="space">/</span>{{infoDetail.TypeName}}<span class="space">/</span>{{infoDetail.Title}}</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div info_detail_box">
			
			<h1>{{infoDetail.Title}}</h1>
			<div class="infoContent" v-html="infoContent"></div>
			
		</div>		
		
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getInfoDetail
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	export default {
		name: 'TW_About',
		mixins: [mixin],
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				language: 'tw', //语言版本
				Id: '', //当前id
				fullscreenLoading: true, //loading状态
				
				infoDetail: {}, //详情				
				infoContent: '',	//富文本详情
			}
		},
		created() {
			// 模拟获取url参数
			this.Id = this.$route.query.Id
			this.getDetail()
		},
		mounted() { //组件挂载到 DOM 后触发

		},
		methods: {			
			//查看详情
			async getDetail() {
				const {
					data: res
				} = await getInfoDetail(this.language, this.Id)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.infoDetail = res.data
					this.infoContent = res.data.Content
					
					this.$nextTick(() => {
						window.scrollTo(0, 0);
					});
				} else {
					this.$message.error(res.errmsg);
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.info_detail_box {
			margin-top: 40px;
			min-height: 650px;
			
			h1 {
				font-size: 28px;
				font-weight: 500;
				line-height: 160%;
			}
			
			.infoContent {
				width: 100%;
				font-size: 15px;
				line-height: 180%;
				margin: 20px 0 40px 0;
				position: relative;
				overflow: hidden;
				
				/deep/ p,div {
					margin: 10px 0;
				}
				
				img {
					max-width: 100%;
				}
			}
			
		}
		
	}
</style>